export default "__VITE_ASSET__D659kok9__"